import { ROLES } from '../constants';
import { useAuthStore } from '../store';

export const useIsInternalSupport = () => {
  const {
    authValues: { loggedUser },
  } = useAuthStore();

  return {
    isInternalSupport: Boolean(loggedUser?.internal_support_user),
    isPartnerCarrier: Boolean(
      loggedUser?.roles?.includes(ROLES.PARTNER_CARRIER),
    ),
  };
};
